import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface RecipeFileReceivedProps extends BaseTemplateProps {
  fileName: string
}

export const RecipeFileReceived: TemplateDefinition<RecipeFileReceivedProps> = {
  renderParams: (props: RecipeFileReceivedProps) => ({
    messageKey: 'notificationsDomain.templates.recipeFileReceived',
    values: { fileName: props.fileName },
  }),
}
